import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-esports-ha',
    templateUrl: './default/esports-ha/esports-ha.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class EsportsHandicapComponent extends UnitsDistributionBase {
  // Used for ESPORTS_HA
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}